function logError(...args: unknown[]): void {
  const devFlag: unknown = import.meta.env.DEV
  const mode: unknown = import.meta.env.MODE

  if (devFlag === true || devFlag === 'true' || mode === 'development') {
    globalThis.console.error(...args)
  }
}

export { logError }
